module.exports = __webpack_public_path__ + "static/media/page03.b201f91d.jpg";